import React from 'react';
import { Grid, Box } from '@mui/material';
import ProductCard from './ProductCard';


export default function ProductList({products}) {

  return (
    <Box sx={{ pb:8, ml: 0.4, maxWidth: '100%', overflow: 'hidden'}}>
        <Grid container >
        {products.map((product, index) => (
            <Grid item  size={{ xs: 6, sm: 4 }} 
            key={product.id || `product-${index}`} // Use a fallback key if product.id is not unique
            >
            <ProductCard product={product} />
            </Grid>
        ))}
        </Grid>
    </Box>

  );
}